module.exports = "/_next/static/images/bcf395bc88d1b6499845c1061d344fbc-slide-1-large.png";